import React, { useRef, useEffect, useState } from 'react'
import styles from './StageListen.module.css'

import IconPlay from '../../../../assets/icons/IconPlay'
import IconPause from '../../../../assets/icons/IconPause'
import { getSoundDownloadUrl } from '../components/Sound/Sound'

const Sentence = ({
    sentence,
    style,
    onPlayClick,
    playing,
    played,
}) => {
    return (
        <div
            className={styles.sentenceContainer}
            onClick={onPlayClick}
            style={played ? { backgroundColor: 'white', ...style } : {...style}}>
            <div
                onClick={onPlayClick}
                className={styles.playButton}>
                {playing ? <IconPause size={24} /> : <IconPlay size={24} />}
            </div>
            <p className={styles.sentenceEng}>{sentence.eng}</p>
            <p className={styles.sentenceHeb}>{sentence.heb}</p>
        </div>
    )
}

const StageListen = ({
    data,
    onPageChange,
}) => {

    const mediaPlayer = useRef(new Audio());
    const [playingIndex, setPlayingIndex] = useState(-1);
    const [audioPlayed, setAudioPlayed] = useState(Array(data.sentences.length).fill(false))
    const [currProgress, setCurrProgress] = useState(0)
    
    const handlePlayClick = (soundPath, index) => {
        getSoundDownloadUrl(soundPath).then((url) => {
            setPlayingIndex(index)
            mediaPlayer.current.src = url;
            mediaPlayer.current.load();
            mediaPlayer.current.play();
        })

    }

    useEffect(() => {
        mediaPlayer.current.addEventListener('ended', onAudioEnded)
        return () => {
            mediaPlayer.current.removeEventListener('ended', onAudioEnded)
        }
    }, [playingIndex])

    const onAudioEnded = () => {
        const updatedAudioPlayed = audioPlayed.slice();
        if (!updatedAudioPlayed[playingIndex]) {
            onPageChange(currProgress + 1)
            setCurrProgress((prevState) => prevState + 1)
        }
        updatedAudioPlayed[playingIndex] = true;
        setPlayingIndex(-1)
        setAudioPlayed(updatedAudioPlayed)
    }


    return (
        <div
            className={styles.container}>
            <p className={styles.title}>Practice reading and practice listening</p>
            {
                data.sentences[0].eng !== '' ? null :
                    <p className={styles.subTitle}>There is no need to understand the phrases</p>
            }
            <div style={{ padding: '16px' }} />
            {
                data.sentences.map((sentence, index) => {
                    return (
                        <Sentence
                            playing={playingIndex === index}
                            onPlayClick={() => handlePlayClick(sentence.sound_path, index)}
                            style={index + 1 === data.sentences.length ? { borderBottom: '1px solid rgba(0,0,0,0.3)' } : {}}
                            sentence={sentence}
                            played={audioPlayed[index]} />
                    )
                })
            }
            <div style={{padding: '40px'}}/>

        </div>
    )
}

export default StageListen
